//Global imports
import { CFormInput, CFormLabel, CFormTextarea } from '@coreui/react';

//File imports
import { Language } from '../../../../language/English';

//Component imports
import { HintText, LengthChecker } from '../../../../components';
import { DOCUMENT } from 'stylis';
import { DOCUMENT_DETAIL_PAGE_INFO } from '../../../../Constant';
import StringUtils from '../../../../services/StringUtils/StringUtils';

interface SeoFieldsProps {
    onBlurUrlField: (e: React.FocusEvent<HTMLInputElement>) => void;
    handleChange: (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => void;
    handlePaste: (e: React.ClipboardEvent<HTMLTextAreaElement>) => void;
    onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    data: {
        metaTitle: string;
        metaKeyword: string;
        metaDescription: string;
    };
    errors: {
        metaTitle?: string;
        metaKeyword?: string;
        metaDescription?: string;
    };
    stringUtils: StringUtils;
    name: string;
    metaTitleHint?: string;
    metaKeywordHint?: string;
    metaDescriptionHint?: string;
}

const SeoFields: React.FC<SeoFieldsProps> = ({
    onBlurUrlField,
    handleChange,
    handlePaste,
    onKeyDown,

    data,
    errors,
    stringUtils,
    name,
    metaTitleHint = Language.META_TITLE_HINT,
    metaKeywordHint = Language.META_KEYWORD_HINT,
    metaDescriptionHint = Language.META_DESCRIPTION_HINT,
}) => {
    return (
        <>
            {/* <CFormLabel htmlFor={stringUtils.convertToCamelCase(Language.URL)}>
                {Language.URL}
            </CFormLabel>
            <CFormInput
                type="text"
                placeholder={`Ex. ${name.toLowerCase().split(' ').join('-')}`}
                value={data?.url || ''}
                invalid={!!errors.url}
                feedback={errors.url}
                onChange={handleChange}
                onBlur={onBlurUrlField}
                name={stringUtils.convertToCamelCase(Language.URL)}
                maxLength={200}
            />
            <LengthChecker
                currentLength={data?.url?.length || 0}
                maxLength={200}
            /> */}

            <CFormLabel
                style={{ marginBottom: 0 }}
                htmlFor={stringUtils.convertToCamelCase(Language.GOOGLE_TITLE)}
            >
                {Language.GOOGLE_TITLE}
            </CFormLabel>
            <HintText marginBottom="10px">{metaTitleHint}</HintText>
            <CFormInput
                type="text"
                value={data?.metaTitle || ''}
                placeholder={Language.ENTER_GOOGLE_TITLE}
                onChange={handleChange}
                invalid={!!errors.metaTitle}
                feedback={errors.metaTitle}
                name={stringUtils.convertToCamelCase(Language.META_TITLE)}
                maxLength={300}
            />
            <LengthChecker
                currentLength={data?.metaTitle?.length || 0}
                maxLength={300}
            />

            <CFormLabel
                style={{ marginBottom: 0 }}
                htmlFor={stringUtils.convertToCamelCase(
                    Language.GOOGLE_KEYWORD,
                )}
            >
                {Language.GOOGLE_KEYWORD}
            </CFormLabel>
            <HintText marginBottom="10px">{metaKeywordHint}</HintText>
            <CFormInput
                type="text"
                placeholder={Language.META_KEYWORD_PLACEHOLDER}
                onChange={handleChange}
                value={data?.metaKeyword || ''}
                invalid={!!errors.metaKeyword}
                feedback={errors.metaKeyword}
                name={stringUtils.convertToCamelCase(Language.META_KEYWORD)}
                maxLength={300}
            />
            <LengthChecker
                currentLength={data?.metaKeyword?.length || 0}
                maxLength={300}
            />

            <CFormLabel
                style={{ marginBottom: 0 }}
                htmlFor={stringUtils.convertToCamelCase(
                    Language.GOOGLE_DESCRIPTION,
                )}
                className="mt-3"
            >
                {Language.GOOGLE_DESCRIPTION}
            </CFormLabel>
            <HintText marginBottom="10px">{metaDescriptionHint}</HintText>
            <CFormTextarea
                placeholder={Language.ENTER_GOOGLE_DESCRIPTION}
                onChange={handleChange}
                onPaste={handlePaste}
                onKeyDown={onKeyDown}
                value={data?.metaDescription || ''}
                invalid={!!errors.metaDescription}
                feedback={errors.metaDescription}
                style={{ height: 180 }}
                name={stringUtils.convertToCamelCase(Language.META_DESCRIPTION)}
                maxLength={1000}
            />
            <LengthChecker
                currentLength={data?.metaDescription?.length || 0}
                maxLength={1000}
            />
        </>
    );
};

export default SeoFields;
